<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="point-terms-of-service">
      <Title jpn="Points Terms of Use" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Regarding the use of “points” (defined below) in Gacha24 (referred to as the “Service”) provided by Iranoan Co., Ltd. (referred to as the “Company”), Terms and conditions (referred to as "Points Terms of Use").</span>
            <span class="text">Please consider purchasing points after thoroughly confirming the contents of the points terms and conditions.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="ARTICLE 1 - DEFINITION OF TERMS"
        >
          <div class="text-container">
            <span class="text">The meanings of the terms in the following items in the Terms shall be as set forth in the respective items.</span>
            <span class="text">(1) "Service Agreement" means the agreement regarding the use of the Service.</span>
            <span class="text">(2) "Service user" means a person who has entered into a service agreement with us.</span>
            <span class="text">(3) "Account Information" means information about a Service User that a Service User has registered with the Service.</span>
            <span class="text">(4) “Points” means in-game virtual currency that can only be used within the Service.</span>
            <span class="text">(5) “Use balance” means the balance of points that the service user possesses and can use.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="Article 2 - Points"
        >
          <div class="text-container">
            <span class="text">(1) Service users can purchase points that can be used in the Service at the amount indicated in the Service by the Company in accordance with the method prescribed by the Company. In addition, the Company may set purchase units, payment methods, usage periods and other purchase conditions for the purchase of points for service users, and the set purchase conditions and payable amounts, etc. shall be subject to the Service or the Company. Posted in the service we operate.</span>
            <span class="text">(2) At the time when the service user expresses their intention to purchase points in accordance with the method prescribed by the Company, the contract between the service user and the Company concerning the purchase of said points shall be concluded, and the total amount of purchase shall be determined. will do.</span>
            <span class="text">(3) If the service user who purchases points is a minor, the service user must obtain the consent of the person with parental authority in advance for the purchase of points.</span>
            <span class="text">(4) If a minor purchases points, the Company will deem that the parent has consented to the purchase of the points.</span>
            <span class="text">(5) The service user's usage balance displayed in the Service will be recorded in the telecommunications equipment related to the provision of the Service and other services operated by the Company, linked to account information.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="Article 3 - Use of Points"
        >
          <div class="text-container">
            <span class="text">(1) Points can be used by the Company to purchase products within the Service.</span>
            <span class="text">(2) Service users can acquire products provided by the Company within the balance of points.</span>
            <span class="text">(3) If a service user uses points to purchase a product from the Company, the amount will be deemed to have been paid by deducting the price of the product from the point balance. In addition, unless otherwise specified, the points given free of charge by the Company to the service user within the Service shall be preferentially consumed.</span>
            <span class="text">(4) Service users can check the balance of points within the Service. In addition, service users shall manage and confirm the increase or decrease of points at their own responsibility.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="Article 4 - Handling of Points"
        >
          <div class="text-container">
            <span class="text">(1) The Company shall grant points to the User in accordance with the method stipulated by the Company when the User purchases points in the Service, when the Company implements a campaign, or in other cases. The purchase unit, price, validity period, and other conditions for granting points shall be determined by the Company and displayed on the Service.</span>
            <span class="text">(2) Points are valid for 6 months from the date they are awarded.</span>
            <span class="text">(3) The Company shall not refund any points acquired by the User, except as required by law. The refund method and conditions for refunding points based on laws and regulations shall be posted in a manner separately determined by the Company.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="Article 5 - Prohibition of redemption, etc."
        >
          <div class="text-container">
            <span class="text">Regarding all content acquired in this service, regardless of the means such as mediation by a third party or Internet auction, any transfer, transfer, or lending in the form of giving and receiving money or other consideration in the real world , borrowing, etc. (including but not limited to so-called RMT [Real Money Trade]. In addition, including giving and receiving money or other consideration in the real world for the actions of users in this service. ) is prohibited.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="Article 6 - Transfer of Points, etc."
        >
          <div class="text-container">
            <span class="text">Service users may not assign, lend, gift or otherwise transfer points and products to a third party, or set pledges or other security interests.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="Article 7 - Suspension of purchasing and using points, etc."
        >
          <div class="text-container">
            <span class="text">If the service user falls under any of the following, the Company may take measures that the Company deems appropriate (including, but not limited to, purchase of points or suspension of use). .</span>
            <span class="text">(1) Acquisition and use of points or products by illegal means;</span>
            <span class="text">(2) When the service user violates the Terms</span>
            <span class="text">(3) In addition, when the Company determines that the use of the Service by the Service User is inappropriate.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Established November 10, 2021</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title.vue';
import t from '@/plugins/i18n_point_terms_of_service';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.point-terms-of-service{
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  color: $white;
  @include appendMap($backgroundStyleMap);
  .point-terms-of-service-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          color: $white;
          a {
            color: $white!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
